import { render, staticRenderFns } from "./YedeerLayoutPhone.vue?vue&type=template&id=3f2e4e7b&scoped=true&"
import script from "./YedeerLayoutPhone.vue?vue&type=script&lang=js&"
export * from "./YedeerLayoutPhone.vue?vue&type=script&lang=js&"
import style0 from "./YedeerLayoutPhone.vue?vue&type=style&index=0&id=3f2e4e7b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2e4e7b",
  null
  
)

export default component.exports